import "core-js/modules/es6.array.fill";
import _classCallCheck from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf";
import _inherits from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/inherits";
import * as tslib_1 from "tslib";
import { Component, Vue, Prop } from "vue-property-decorator";
import { i18n } from "@/i18n/i18n-setup";

var CircleRingChart =
/*#__PURE__*/
function (_Vue) {
  _inherits(CircleRingChart, _Vue);

  function CircleRingChart() {
    var _this;

    _classCallCheck(this, CircleRingChart);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CircleRingChart).apply(this, arguments));
    _this.cavsWidth = 270;
    _this.cavsHeight = 100;
    _this.ctx = null;
    _this.radCenter = 45;
    return _this;
  }

  _createClass(CircleRingChart, [{
    key: "initCanvas",
    value: function initCanvas() {
      var _this2 = this;

      this.$nextTick(function () {
        var cavs = _this2.$refs.pieCavs;
        _this2.ctx = cavs.getContext('2d'); //获取画笔

        if (_this2.ctx) {
          if (window.devicePixelRatio) {
            //清除canvas在移动端的锯齿
            cavs.style.width = _this2.cavsWidth + "px";
            cavs.style.height = _this2.cavsHeight + "px";
            cavs.width = _this2.cavsWidth * window.devicePixelRatio;
            cavs.height = _this2.cavsHeight * window.devicePixelRatio;

            _this2.ctx.scale(window.devicePixelRatio, window.devicePixelRatio);
          }

          _this2.drawFn();
        }
      });
    }
  }, {
    key: "drawFn",
    value: function drawFn() {
      this.drawRing(this.ctx, '#F6F5F7', 40, Math.PI * 1.5); //灰色的

      this.drawRing(this.ctx, '#603BF3', 40, Math.PI * (this.chartData[this.blueData] / 100) * 2 - Math.PI / 2); //蓝色的

      this.drawRing(this.ctx, '#F6F5F7', 30, Math.PI * 1.5); //灰色的

      this.drawRing(this.ctx, '#F26C6A', 30, Math.PI * (this.chartData[this.orageData] / 100) * 2 - Math.PI / 2); //桔红色的

      this.drawCircle(this.ctx, '#F6F5F7', 50, 50, 8);
      this.drawCircle(this.ctx, '#603BF3', 140, 30, 4);
      this.drawCircle(this.ctx, '#F26C6A', 140, 68, 4);
      this.ctx.font = '16px Assistant-SemiBold';
      this.ctx.fillStyle = 'rgb(66,65,69)';
      this.ctx.fillText(this.chartData[this.blueData] + '%', 150, 35);
      this.ctx.fillText(this.chartData[this.orageData] + '%', 150, 72);
      this.ctx.font = '14px Assistant-Regular';
      this.ctx.fillStyle = 'rgb(171,168,184)';
      this.ctx.fillText(i18n.t("circle_ring." + this.blueData), 190, 35);
      this.ctx.fillText(i18n.t("circle_ring." + this.orageData), 190, 72);
    }
  }, {
    key: "drawRing",
    value: function drawRing(ctx, color, r, rad) {
      ctx.save();
      ctx.beginPath();
      ctx.strokeStyle = color;
      ctx.lineWidth = 6; //画笔的粗细

      ctx.lineCap = "round";
      ctx.arc(50, 50, r, -Math.PI / 2, rad); //画圆

      ctx.stroke();
      ctx.restore();
    }
  }, {
    key: "drawCircle",
    value: function drawCircle(ctx, color, x, y, r) {
      ctx.save();
      ctx.beginPath();
      ctx.fillStyle = color;
      ctx.arc(x, y, r, 0, Math.PI * 2); //画圆

      ctx.fill();
      ctx.restore();
    }
  }, {
    key: "drawText",
    value: function drawText(ctx, color, x, y, text, size, family) {
      ctx.textAlign = "left";
      ctx.textBaseline = "middle";
      ctx.font = size + 'px' + family;
      ctx.fillStyle = color;
      ctx.fillText(text, x, y);
    }
  }, {
    key: "mounted",
    value: function mounted() {
      this.initCanvas();
    }
  }]);

  return CircleRingChart;
}(Vue);

tslib_1.__decorate([Prop({
  default: ''
})], CircleRingChart.prototype, "chartData", void 0);

tslib_1.__decorate([Prop({
  default: ''
})], CircleRingChart.prototype, "blueData", void 0);

tslib_1.__decorate([Prop({
  default: ''
})], CircleRingChart.prototype, "orageData", void 0);

CircleRingChart = tslib_1.__decorate([Component({
  components: {}
})], CircleRingChart);
export default CircleRingChart;